import { forwardRef } from 'react';

import { Hint, HintElement, HintProps } from '../Hint/index.js';

export type HotKeyElement = HintElement;
export interface HotkeyHintProps extends Omit<HintProps, 'children'> {
  binding: string;
}

export const HotkeyHint = forwardRef<HotKeyElement, HotkeyHintProps>(
  ({ binding, ...restProps }, fowardedRef) => {
    return (
      <Hint ref={fowardedRef} {...restProps}>
        {binding}
      </Hint>
    );
  }
);
